import React, { useState } from 'react';
import '../../CSS/cardStudio.css';
import { TextField, Typography, Slider, Box, Grid, FormControlLabel, RadioGroup, Radio, FormLabel, Switch } from '@mui/material';
import { useStudio } from '../../Context/StudioContext';
import ProgrammeSchedule from '../../Components/CardStudio/ProgrammeSchedule';



const Page4Settings = () => {
    const { formData, setFormData } = useStudio();

    const handleChange = (field) => (e) => {
        setFormData(prev => ({ ...prev, [field]: e.target.value }));
    };


    return (
        <Box>
            <Typography variant="h6">Maklumat Majlis</Typography>

            <TextField
                label="Alamah Penuh Lokasi"
                fullWidth
                multiline
                minRows={3}
                value={formData.eventAddress}
                onChange={handleChange('eventAddress')}
                margin="normal"
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="Link Google Maps"
                fullWidth
                value={formData.googleMapLink}
                placeholder='https://maps.app.goo.gl/y5ffFiUnJKjPc59G6'
                onChange={handleChange('googleMapLink')}
                margin="normal"
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="Link Waze"
                fullWidth
                value={formData.wazeMapLink}
                placeholder='https://www.waze.com/en/live-map/directions/my/kedah/kulim/dewan-putra-kulim?place=ChIJ0UL7ae_LSjARiFlXZVZQd2A'
                onChange={handleChange('wazeMapLink')}
                margin="normal"
                InputLabelProps={{ shrink: true }}
            />

            <Typography variant="body2" color='text.secondary' sx={{ mt: 1 }}>Atur Cara Majlis</Typography>
            <ProgrammeSchedule />

        </Box>


    );
};

export default Page4Settings;
